import { startOfToday, setHours } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";
import { last, padStart } from "lodash";
import { deepFreeze } from "../../../util/misc.js";

const TZ = "America/New_York"; // Default timezone
let intervalMinutes = 15;
const CONFIG = {
  intervalMinutes,
  intervalsPerHour: 60 / intervalMinutes,
  intervalStartHour: 7,
  intervalDurationHours: 11,
  timeSlots: [
    ["08:30", "10:30"],
    ["10:30", "12:30"],
    ["13:30", "15:30"],
  ],
};

// Fill gaps with unavailable slots
let timeSlots = [];
let slotTemplate = Object.freeze({ start: null, end: null, disabled: true });
let firstHour = padStart(CONFIG.intervalStartHour, 2, "0") + ":00";
let lastHour =
  padStart(CONFIG.intervalStartHour + CONFIG.intervalDurationHours, 2, "0") +
  ":00";
CONFIG.timeSlots.forEach((slot, i) => {
  if (i === 0) {
    if (firstHour < slot[0]) {
      timeSlots[0] = { ...slotTemplate, start: firstHour, end: slot[0] };
    }
  } else if (slot[0] > CONFIG.timeSlots[i - 1][1]) {
    timeSlots.push({
      ...slotTemplate,
      start: CONFIG.timeSlots[i - 1][1],
      end: slot[0],
    });
  }
  timeSlots.push({
    ...slotTemplate,
    start: slot[0],
    end: slot[1],
    disabled: false,
  });
});
if (last(timeSlots).end < lastHour) {
  timeSlots.push({
    ...slotTemplate,
    start: last(timeSlots).end,
    end: lastHour,
  });
}
let toHours = (time) =>
  time
    .split(":")
    .reduce(
      (hours, qty, i) =>
        hours + (i ? parseInt(qty, 10) / 60 : parseInt(qty, 10)),
      0
    );
timeSlots.forEach((slot) => {
  slot.hours = toHours(slot.end) - toHours(slot.start);
});
CONFIG.timeSlots = timeSlots;
deepFreeze(CONFIG);

// Getters
export const timezone = (state) => {
  return state.user?.locations?.[0]?.timeZone || TZ;
};

export const slotDateTime = (state) => (slotIndex, date) => {
  const slot = { ...CONFIG.timeSlots[slotIndex] };
  let start = `${date} ${slot.start}:00`;
  let end = `${date} ${slot.end}:00`;
  slot.start = zonedTimeToUtc(start, timezone(state));
  slot.end = zonedTimeToUtc(end, timezone(state));
  return slot;
};

export const calendarConfig = (state) => {
  let today = startOfToday();
  let config = { ...CONFIG };

  // Adjust for current local timezone
  config.intervalStartHour = zonedTimeToUtc(
    setHours(today, config.intervalStartHour),
    timezone(state)
  ).getHours();

  return config;
};
